import inViewport from '@resources/js/helpers/inViewport'

const faqSectionElement = document.querySelector('.js-faq')

inViewport(faqSectionElement, async () => {
	const faqItemElements = faqSectionElement.querySelectorAll('.js-faq-item')
	if (!faqItemElements.length) return

	const { default: Accordion } = await import('@resources/js/ui/Accordion')
	const { isMobile } = await import('@resources/js/helpers/media')

	const isMobileView = isMobile()

	const faqAccordion = new Accordion(faqItemElements, {
		multiple: !isMobileView,
		behavior: 'smooth',
	})

	if (!isMobileView) faqAccordion.closeAll()

	faqAccordion.open(0)
})
